<script lang="ts" setup generic="T extends PropertyKey = string">
  import { ref } from 'vue'

  const props = defineProps<{
    options: Array<{ label: string; value: T }>
    placeholder?: string
    modelValue?: T
  }>()

  const selected = ref<T | ''>('')
  const emit = defineEmits<{
    (e: 'update:modelValue', value: T): void
    (e: 'select', value: T): void
  }>()

  const handleChange = (event: Event) => {
    const value = (event.target as HTMLSelectElement).value as T
    selected.value = value
    emit('update:modelValue', value)
    emit('select', value)
  }
</script>
<template>
  <div class="dropdown-widget">
    <select
      class="dropdown-select"
      :value="props.modelValue ?? selected"
      @change="handleChange"
    >
      <option value="" disabled selected>
        {{ props.placeholder || 'Selecciona una opción' }}
      </option>
      <option
        v-for="option in props.options"
        :key="option.value"
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </select>
  </div>
</template>
<style scoped>
  .dropdown-widget {
    width: 100%;
    margin: 0.5rem 0;
  }
  .dropdown-select {
    width: 100%;
    padding: 0.5rem 1rem;
    border-radius: 8px;
    border: 1px solid #ccc;
    font-size: 1rem;
    background: #fff;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
    outline: none;
    transition: border-color 0.2s;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .dropdown-select:focus {
    border-color: #2563eb;
  }
</style>
